import { useMemo, useRef } from "react";
import type { Group } from "three";
import { useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

useGLTF.preload("/models/ufo.glb");

export function Ufo3D({ rotation = 0 }: { rotation: number }) {
  const groupRef = useRef<Group>(null);
  const { scene } = useGLTF("/models/ufo.glb");

  useFrame((state) => {
    if (groupRef.current) {
      // Smoothly interpolate rotation for fluid movement
      // We rotate around Z for 2D tilt.
      // Note: Chart Y is inverted (down is positive), so we might need to invert angle sign.
      groupRef.current.rotation.z = THREE.MathUtils.lerp(
        groupRef.current.rotation.z,
        rotation,
        0.1,
      );

      // Y rotation: oscillate between 20 and -20 degrees every 1s (half-period)
      const time = state.clock.elapsedTime;
      // Full cycle (20 -> -20 -> 20) takes 2 seconds -> frequency = PI
      const speed = Math.PI;
      const amplitude = THREE.MathUtils.degToRad(10);

      groupRef.current.rotation.x = Math.cos(time * speed) * amplitude;
    }
  });

  return (
    <group ref={groupRef} scale={25} dispose={null}>
      {/* 3D Model */}
      <primitive
        object={scene.clone()}
        rotation={[0, 0, 0]}
        position={[0, 0, 0]} // Center visual offset if needed
      />
    </group>
  );
}
